/**
 * @generated SignedSource<<3a8cbbc521dea870a16bbd4819d25cd9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type SurveyStatus = "AVAILABLE" | "FAIL" | "PENDING" | "SUCCESS";
import { FragmentRefs } from "relay-runtime";
export type useFinishedSurveyCardFragmentQuery_surveyRef$data = {
  readonly durationDetails: {
    readonly providerDuration: number;
  };
  readonly id: string;
  readonly rewardAmount: {
    readonly formatted: string;
  } | null;
  readonly startedAt: string | null;
  readonly status: SurveyStatus;
  readonly statusDescription: string;
  readonly studyId: string | null;
  readonly supportId: string | null;
  readonly surveyId: string | null;
  readonly tags: ReadonlyArray<string>;
  readonly title: string;
  readonly " $fragmentType": "useFinishedSurveyCardFragmentQuery_surveyRef";
};
export type useFinishedSurveyCardFragmentQuery_surveyRef$key = {
  readonly " $data"?: useFinishedSurveyCardFragmentQuery_surveyRef$data;
  readonly " $fragmentSpreads": FragmentRefs<"useFinishedSurveyCardFragmentQuery_surveyRef">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useFinishedSurveyCardFragmentQuery_surveyRef",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "statusDescription",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "supportId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "surveyId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "studyId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "tags",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "startedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "CurrencyAmount",
      "kind": "LinkedField",
      "name": "rewardAmount",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "formatted",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "DurationDetails",
      "kind": "LinkedField",
      "name": "durationDetails",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "providerDuration",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Survey",
  "abstractKey": null
};

(node as any).hash = "d5b8d82edc1569679b30076a19478fc0";

export default node;
